module.exports = __webpack_public_path__ + "img/daihatsu-logo.55d429db.svg";